import styled from 'styled-components'

export const StyledPaginationContainer = styled.div`
  position: absolute;
  bottom: -62px;
  left: 0;
  padding: 16px;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const StyledPageSizeOptions = styled.div`
  display: flex;
  gap: 8px;
`

export const StyledPaginationButtons = styled.div`
  display: flex;
`

export const StyledEllipsis = styled.span`
  margin-top: 10px;
`
